<div class="container-recommended" appClickOutsideContainer 
  (clickOutside)="onClickedOutside()"
  [permittedElement]="'nav-bar-algolia-search-box'">
  <button type="button" class="close pull-right btn-close-recommended" (click)="onClickedOutside()" aria-label="Close">
    <app-icons class="close-icon"  [type]="'close'" [color]="'#418fde'"></app-icons>
  </button>
  <section class="recent">
    <h4 *ngIf="customer && labels">Vistos recientemente</h4>
    <h4 *ngIf="!customer && labels">Lo más buscado</h4>
    <div class="labels" id="labels">
      <div *ngFor="let item of labels; let i = index" (click)="searchLabel(item.description || item)">
        <a *ngIf="i < 6"><p >{{ item.description || item }}</p></a>
      </div>
    </div>
  </section>
  <section class="offers">
    <h4>Estas son las mejores ofertas</h4>
    <section class="suggested-cont">
      <div *ngFor="let item of productsSuggested; let i=index">
        <a [routerLink]="[item.url]"  *ngIf="i < 10">
          <div class="suggested-item">
            <div class="cont-img" [ngStyle]="{'background-image': 'url(' + item.urlImage + ')'}"></div>
            <div class="cont-description">
              {{ item.description }}
            </div>
          </div>
        </a>
      </div>

    </section>
  </section>
</div>